import { useI18n } from '@affine/i18n';
import {
  createContext,
  createElement,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

const OfficialWebsiteUrlContext = createContext<string | undefined>(undefined);

export const OfficialWebsiteUrlProvider = ({
  children,
  officialWebsiteUrl,
}: PropsWithChildren<{ officialWebsiteUrl?: string }>) => {
  return createElement(
    OfficialWebsiteUrlContext.Provider,
    { value: officialWebsiteUrl },
    children
  );
};

export const useNavConfig = () => {
  const t = useI18n();
  const officialWebsiteUrl = useContext(OfficialWebsiteUrlContext);
  return useMemo(() => {
    const config = [
      {
        title: t['com.affine.other-page.nav.blog'](),
        path: 'https://affine.pro/blog',
      },
      {
        title: t['com.affine.other-page.nav.contact-us'](),
        path: 'https://affine.pro/about-us',
      },
    ];

    if (officialWebsiteUrl) {
      config.unshift({
        title: t['com.affine.other-page.nav.official-website'](),
        path: officialWebsiteUrl,
      });
    }

    return config;
  }, [officialWebsiteUrl, t]);
};
